import {
	CREATE_PURCHASE_ORDER,
	RETRIEVE_PURCHASE_ORDER,
	DELETE_PURCHASE_ORDER,
} from "./types";

import PurchaseOrderDataService from "../services/purchaseOrder.service";
import { parseNumber } from "../helpers/common";

export const createPurchaseOrder =
	(
		id,
		id_company,
		tipe,
		id_card,
		code,
		code_po,
		date,
		due_date,
		note,
		ship_to,
		tax_inclusive,
		detail,
		recurring,
		recurring_name
	) =>
	async (dispatch) => {
		try {
			if (tax_inclusive === "true") {
				tax_inclusive = true;
			}
			if (tax_inclusive === "false") {
				tax_inclusive = false;
			}

			code = code.toString();
			id_card = parseNumber(id_card);

			let formData = {
				id: id,
				id_company: id_company,
				tipe: tipe,
				id_card: id_card,
				code: code,
				code_po: code_po,
				date: date,
				due_date: due_date,
				note: note,
				ship_to: ship_to,
				tax_inclusive: tax_inclusive,
				detail: detail,
				recurring: recurring,
				recurring_name: recurring_name,
			};

			const res = await PurchaseOrderDataService.create(formData);

			dispatch({
				type: CREATE_PURCHASE_ORDER,
				payload: res.data,
			});

			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		}
	};

export const retrievePurchaseOrder = (params) => async (dispatch) => {
	try {
		const res = await PurchaseOrderDataService.getAll(params);

		dispatch({
			type: RETRIEVE_PURCHASE_ORDER,
			payload: res.data,
		});
	} catch (err) {
		return Promise.reject(err);
	}
};

export const deletePurchaseOrder = (id) => async (dispatch) => {
	try {
		const res = await PurchaseOrderDataService.delete(id);

		dispatch({
			type: DELETE_PURCHASE_ORDER,
			payload: res.data,
		});
	} catch (err) {
		return Promise.reject(err);
	}
};
